import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";

import "../pages/About.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import {


  MdFlashOn,
  MdFactCheck,
  MdAutorenew,
  MdSupportAgent,

  MdApartment
} from "react-icons/md";


import {
  MdEco,
  MdSolarPower,
  MdWaterDrop,
  MdRecycling,
  MdEngineering,
  MdPublic,
  MdTrendingUp,
  MdVerified
} from "react-icons/md";

export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  return (
    <>
      <Helmet>
        <title>About RAD EnviroNex | Leading Environmental & Solar Solutions Provider</title>
        <meta name="description" content="Learn about RAD EnviroNex, a trusted provider of solar energy, wastewater treatment, and environmental audit services in Madurai and Tamil Nadu. 9+ years of industry experience." />
        <meta name="keywords" content="About RAD EnviroNex, Environmental Consultants Madurai, Solar Energy Company Tamil Nadu, Waste Management Experts, sustainable engineering, RAD EnviroNex Journey" />
        <link rel="canonical" href="https://radenvironex.com/About" />
      </Helmet>
      <Navbar />


      {/* HERO */}





      {/* <!-- RAD ENVIRONEX STORY SECTION --> */}
      {/* <section id="rad-story-section">
    <div class="rad-story-container">

        <div class="rad-story-header" data-aos="slide-down">
            <h2>Our Journey Towards Sustainable Excellence</h2>
            <p>Building Tamil Nadu’s Future with Smart Environmental Solutions</p>
        </div>

        <div class="rad-story-content">

            <div class="rad-story-left" data-aos="slide-up">
                <h3>Who We Are</h3>
                <p>
                    RADENVIRONEX was founded with a clear mission — to provide advanced,
                    reliable, and sustainable environmental solutions across Tamil Nadu.
                    From renewable energy systems to industrial wastewater management,
                    we deliver solutions that meet modern compliance standards while
                    creating long-term value for industries and communities.
                </p>

                <h3>What Drives Us</h3>
                <p>
                    Innovation, sustainability, and engineering precision define our work.
                    We believe environmental responsibility is not optional — it is
                    essential for long-term industrial growth. Every project we execute
                    reflects quality, efficiency, and regulatory excellence.
                </p>
            </div>

            <div class="rad-story-right" data-aos="slide-up">
                <div class="rad-highlight-box">
                    <h4>Our Core Expertise</h4>
                    <ul>
                        <li>Solar Plantation & Renewable Energy Solutions</li>
                        <li>Sewage Treatment Plants (STP)</li>
                        <li>Effluent Treatment Plants (ETP)</li>
                        <li>Biogas & Organic Waste Systems</li>
                        <li>Green & Environmental Audits</li>
                        <li>Energy Audit & Optimization</li>
                    </ul>
                </div>

                <div class="rad-highlight-box secondary">
                    <h4>Our Commitment</h4>
                    <p>
                        ISO-driven standards, certified engineering practices,
                        and customer-focused project execution across Tamil Nadu.
                    </p>
                </div>
            </div>

        </div>
    </div>
</section>
 */}
























      <section className="about-hero">
        <div className="about-particles"></div>
        <div className="container text-center" data-aos="fade-up">
          <h1>About RAD EnviroNex</h1>
          <p>
            "Nature inspired solution"
          </p>
        </div>
      </section>

      {/* WHO WE ARE */}
      <section className="about-section">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-lg-6" data-aos="slide-right">
              <h2>Who We Are</h2>
              <p>
                RAD EnviroNex is a forward-thinking environmental and renewable
                energy solutions company committed to addressing today’s
                sustainability challenges with practical, results-driven
                solutions.
              </p>
              <p>
                We operate at the intersection of technology, engineering, and
                environmental responsibility—helping industries, institutions,
                and communities transition toward cleaner energy systems and
                compliant environmental practices.
              </p>
              <p>
                Our team brings together expertise across solar power,
                wastewater treatment, waste management, and sustainability
                auditing, ensuring every solution is technically sound,
                economically viable, and environmentally responsible.
              </p>
            </div>

            <div className="col-lg-6 about-icons" data-aos="slide-left">
              <div className="icon-box"><MdEco /> Sustainability</div>
              <div className="icon-box"><MdEngineering /> Engineering Excellence</div>
              <div className="icon-box"><MdVerified /> Regulatory Compliance</div>
            </div>

          </div>
        </div>
      </section>

      {/* WHAT WE DO */}
      {/* <section className="about-dark">
        <div className="container">
          <h2 className="text-center mb-5" data-aos="fade-up">What We Do</h2>

          <div className="row g-4">
            <div className="col-md-6 col-lg-3" data-aos="slide-up">
              <div className="about-card">
                <MdSolarPower />
                <h4>Solar Energy Solutions</h4>
                <p>
                  End-to-end solar installation, commissioning, operation, and
                  maintenance designed for long-term performance and savings.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-3" data-aos="slide-up" data-aos-delay="100">
              <div className="about-card">
                <MdWaterDrop />
                <h4>STP & ETP Systems</h4>
                <p>
                  Efficient wastewater treatment solutions ensuring compliance,
                  reuse, and environmental protection.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-3" data-aos="slide-up" data-aos-delay="200">
              <div className="about-card">
                <MdRecycling />
                <h4>Waste Management</h4>
                <p>
                  Solid waste, biogas, and recycling systems that promote
                  circular economy practices.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-3" data-aos="slide-up" data-aos-delay="300">
              <div className="about-card">
                <MdTrendingUp />
                <h4>Audits & Optimization</h4>
                <p>
                  Energy audits and green audits that identify inefficiencies
                  and unlock cost savings.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}









      <section id="whychoose-us" className="whychoose-section">
        <div className="particle-bg"></div>

        <div className="container">
          <div className="row text-center mb-5">
            <div className="col-12" data-aos="fade-up">
              <h2 className="whychoose-heading">Why Choose RAD EnviroNex</h2>
              <p className="whychoose-sub">
                Built on expertise, driven by sustainability
              </p>
            </div>
          </div>

          <div className="row g-4">

            <div className="col-lg-4 col-md-6" data-aos="slide-up">
              <div className="whychoose-card glass">
                <MdEco />
                <h4>Comprehensive Sustainable Solutions</h4>
                <p>
                  End-to-end renewable energy and environmental services under one roof
                  — solar, biogas, STP, ETP, waste management, and sustainability audits.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6" data-aos="slide-up" data-aos-delay="100">
              <div className="whychoose-card glass">
                <MdEngineering />
                <h4>Technical Expertise & Industry Experience</h4>
                <p>
                  Deep technical knowledge and hands-on experience in designing,
                  executing, and maintaining compliant environmental systems.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6" data-aos="slide-up" data-aos-delay="200">
              <div className="whychoose-card glass">
                <MdFlashOn />
                <h4>Efficiency & Cost Optimization</h4>
                <p>
                  Smart solutions that improve energy efficiency, reduce operating
                  costs, and deliver long-term financial value.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6" data-aos="slide-up">
              <div className="whychoose-card glass">
                <MdFactCheck />
                <h4>Regulatory & Compliance Support</h4>
                <p>
                  Full alignment with environmental norms and regulatory standards,
                  ensuring compliance with confidence and ease.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6" data-aos="slide-up" data-aos-delay="100">
              <div className="whychoose-card glass">
                <MdAutorenew />
                <h4>Customized & Scalable Solutions</h4>
                <p>
                  Tailored, future-ready solutions designed to scale alongside your
                  organization’s evolving requirements.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6" data-aos="slide-up" data-aos-delay="200">
              <div className="whychoose-card glass">
                <MdSupportAgent />
                <h4>Reliable Support & Long-Term Partnership</h4>
                <p>
                  From consultation to after-sales support, we stay committed at every
                  stage with transparency and trust.
                </p>
              </div>
            </div>

            <div className="col-lg-6 col-md-6" data-aos="slide-up">
              <div className="whychoose-card glass">
                <MdPublic />
                <h4>Commitment to Sustainability</h4>
                <p>
                  Sustainability is at the core of everything we do — reducing
                  environmental impact while promoting clean energy and responsible
                  resource management.
                </p>
              </div>
            </div>

            <div className="col-lg-6 col-md-6" data-aos="slide-up" data-aos-delay="100">
              <div className="whychoose-card glass highlight">
                <MdApartment />
                <h4>9+ Years of Industry Experience</h4>
                <p>
                  With over 9 years in renewable energy and environmental management,
                  we bring proven expertise, practical insights, and a strong delivery
                  track record.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>








      {/* APPROACH */}
      {/* <section className="about-section">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-lg-6" data-aos="slide-up">
              <h2>Our Approach</h2>
              <p>
                Every project begins with understanding. We assess site
                conditions, operational goals, and regulatory requirements
                before designing customized solutions.
              </p>
              <p>
                Our implementation process follows global best practices,
                ensuring quality engineering, safety, and performance at every
                stage—from concept to commissioning and beyond.
              </p>
              <p>
                Post-deployment, we remain actively involved through monitoring,
                maintenance, and optimization support.
              </p>
            </div>

            <div className="col-lg-6" data-aos="slide-left">
              <div className="about-highlight">
                <MdPublic />
                <p>
                  We don’t just deliver systems — we build long-term partnerships
                  that support sustainability, compliance, and growth.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section> */}

      {/* CLOSING */}
      {/* <section className="about-cta">
        <div className="container text-center" data-aos="fade-up">
          <h2>Our Commitment</h2>
          <p>
            At RAD EnviroNex, sustainability is not a trend — it is our
            responsibility. We are committed to supporting India’s transition
            toward a cleaner, greener, and net-zero future through innovation,
            integrity, and impact-driven solutions.
          </p>
        </div>
      </section> */}
      {/* MISSION VISION VALUES */}
      {/* <section className="about-mvv">
        <div className="container">
          <div className="row text-center mb-5" data-aos="fade-up">
            <h2>Our Mission, Vision & Values</h2>
            <p className="sub">
              What drives RAD EnviroNex every day
            </p>
          </div>

          <div className="row g-4">
            <div className="col-md-4" data-aos="slide-up">
              <div className="mvv-card">
                <MdTrendingUp />
                <h4>Our Mission</h4>
                <p>
                  To deliver innovative, reliable, and sustainable environmental
                  and renewable energy solutions that reduce carbon footprint,
                  optimize resources, and support long-term compliance.
                </p>
              </div>
            </div>

            <div className="col-md-4" data-aos="slide-up" data-aos-delay="100">
              <div className="mvv-card">
                <MdPublic />
                <h4>Our Vision</h4>
                <p>
                  To be a trusted force in India’s clean energy transition,
                  supporting the journey toward a Net-Zero future through
                  responsible innovation and scalable solutions.
                </p>
              </div>
            </div>

            <div className="col-md-4" data-aos="slide-up" data-aos-delay="200">
              <div className="mvv-card">
                <MdVerified />
                <h4>Our Values</h4>
                <p>
                  Integrity, transparency, sustainability-first thinking, and
                  long-term partnerships guide every project we deliver.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* CORE STRENGTHS */}
      {/* <section className="about-strengths">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6" data-aos="slide-right">
              <h2>Our Core Strengths</h2>
              <p>
                RAD EnviroNex combines technical depth with practical execution.
                Our strength lies in understanding regulations, engineering
                systems that last, and delivering solutions that perform beyond
                expectations.
              </p>
              <p>
                From feasibility studies to long-term maintenance, we take full
                ownership of outcomes — not just installations.
              </p>
            </div>

            <div className="col-lg-6" data-aos="slide-left">
              <ul className="strength-list">
                <li>✔ Proven engineering expertise</li>
                <li>✔ Regulatory-ready system design</li>
                <li>✔ Cost-optimized solutions</li>
                <li>✔ Reliable after-deployment support</li>
              </ul>
            </div>
          </div>
        </div>
      </section> */}

      {/* SUSTAINABILITY ROADMAP */}
      {/* <section className="about-roadmap">
        <div className="container text-center" data-aos="fade-up">
          <h2>Sustainability Roadmap</h2>
          <p>
            Supporting India and Tamil Nadu’s long-term sustainability goals
            through measurable environmental impact.
          </p>

          <div className="roadmap-steps">
            <span>Assess</span>
            <span>Design</span>
            <span>Implement</span>
            <span>Optimize</span>
            <span>Sustain</span>
          </div>
        </div>
      </section> */}
      <Footer />
    </>
  );
}
